const PRE_OPEN_RECORD_STORAGE_KEY = "tea-shop-pre-open-table-records"

const getRecordMap = (): Record<string, true> => {
  if (typeof localStorage === "undefined") return {}
  try {
    const value = localStorage.getItem(PRE_OPEN_RECORD_STORAGE_KEY)
    return value ? JSON.parse(value) : {}
  } catch (_error) {
    return {}
  }
}

const setRecordMap = (value: Record<string, true>) => {
  if (typeof localStorage === "undefined") return
  localStorage.setItem(PRE_OPEN_RECORD_STORAGE_KEY, JSON.stringify(value))
}

export const markPreOpenTable = (tableRecordId?: number | null) => {
  if (!tableRecordId) return
  const recordMap = getRecordMap()
  recordMap[String(tableRecordId)] = true
  setRecordMap(recordMap)
}

export const clearPreOpenTable = (tableRecordId?: number | null) => {
  if (!tableRecordId) return
  const recordMap = getRecordMap()
  delete recordMap[String(tableRecordId)]
  setRecordMap(recordMap)
}

export const isPreOpenTable = (tableInfo?: unknown) => {
  if (!tableInfo || typeof tableInfo !== "object") return false
  const current = tableInfo as Record<string, unknown> & {
    tableRecordFields?: { preOpenFlag?: unknown } | null
  }
  const backendFlag = current.preOpenFlag
    ?? current.preOpeningFlag
    ?? current.preOpenStatus
    ?? current.isPreOpen
    ?? current.preOpen
    ?? current.tableRecordFields?.preOpenFlag
  const tableRecordId = typeof current.tableRecordId === "number" ? current.tableRecordId : undefined
  return backendFlag === 1 || backendFlag === true || (!!tableRecordId && !!getRecordMap()[String(tableRecordId)])
}

export const withPreOpenFlag = <T extends object>(payload: T, preOpen: boolean) => {
  return preOpen ? { ...payload, preOpenFlag: 1 as const } : { ...payload }
}

const toNumber = (value: unknown) => {
  if (typeof value !== "number" || !Number.isFinite(value)) return undefined
  return value
}

export const getPreOpenCardTotalFee = (tableInfo?: unknown, fallbackTotalFee?: number) => {
  if (!tableInfo || typeof tableInfo !== "object") return undefined
  const current = tableInfo as Record<string, unknown>
  const totalFee = toNumber(current.totalFee)
  if (!isPreOpenTable(current)) return totalFee

  const totalItemAmount = toNumber(current.totalItemAmount)
  if (totalItemAmount !== undefined) {
    const totalItemDiscount = toNumber(current.totalItemDiscount) ?? 0
    return Math.max(0, totalItemAmount - totalItemDiscount)
  }

  const totalTableFee = toNumber(current.totalTableFee) ?? 0
  const totalServiceFee = toNumber(current.totalServiceFee) ?? 0
  if (totalFee !== undefined && (totalTableFee > 0 || totalServiceFee > 0)) {
    return Math.max(0, totalFee - totalTableFee - totalServiceFee)
  }

  if (fallbackTotalFee !== undefined) return fallbackTotalFee

  return totalFee
}
